<template>
    <Modal name="add-phrase" title="Фраза" @closed="onClose">
        <template #content>
            <form class="form" @submit.prevent="save()">
                <Spinner v-if="loading" />
                <div class="form-group">
                    <label class="form-group__label">Исходный текст</label>
                    <FormInput
                        v-model="localPhrase.phrase"
                        type="text"
                        placeholder="Введите фразу"
                        name="phrase"
                        required
                        style="margin-top: 10px"
                    />
                </div>
                <div class="form-group">
                    <label class="form-group__label">Замена</label>
                    <textarea
                        ref="replace"
                        v-model="localPhrase.replace"
                        class="form-group__textarea"
                        placeholder="Введите замену"
                        rows="2"
                        required
                        style="display: block; margin-top: 10px"
                    ></textarea>
                </div>
                <template v-if="!phrase">
                    <div class="form-group">
                        <label class="form-group__label">Язык</label>
                        <MultiSelect
                            v-model="localPhrase.lang"
                            :options="languages"
                            :form-value-text="
                                (item) => item.label.original || item.label[$i18n.locale]
                            "
                            with-filter
                            emit-prop="id"
                            empty-text="No languages"
                            style="width: 360px"
                            required
                        >
                            <template #default="{ item }">
                                {{ item.label.original || item.label[$i18n.locale] }}
                            </template>
                        </MultiSelect>
                    </div>
                    <div class="form-group">
                        <label class="form-group__label">Провайдер</label>
                        <CustomSelect
                            v-model="localPhrase.provider"
                            :options="providers"
                            :form-value-text="(item) => item.name"
                            emit-prop="id"
                            style="max-width: 360px; margin-top: 10px"
                            required
                        >
                            <template #default="{ item }">
                                {{ item.name }}
                            </template>
                        </CustomSelect>
                    </div>
                </template>
                <div class="form-group">
                    <Switcher v-model="localPhrase.is_active">Активна</Switcher>
                </div>
                <div style="display: flex; align-items: center">
                    <button :disabled="loading" class="button button--medium" @click="keep = false">
                        Сохранить
                    </button>
                    <button
                        :disabled="loading"
                        class="button button--medium button--outlined"
                        style="margin-left: 15px"
                        @click="keep = true"
                    >
                        Сохранить и добавить ещё
                    </button>
                </div>
                <ErrorList :error="error" />
            </form>
        </template>
    </Modal>
</template>

<script>
import { ApiClient } from '@/plugins/axios';
import { Modal } from '@speechki-frontend/shared/ui/modals';
import {
    FormInput,
    CustomSelect,
    ErrorList,
    MultiSelect,
} from '@speechki-frontend/shared/ui/forms';
import Switcher from '@speechki-frontend/shared/ui/Switcher/Switcher';

export default {
    name: 'DictionaryPhraseModal',
    components: {
        Modal,
        FormInput,
        CustomSelect,
        Switcher,
        ErrorList,
        MultiSelect,
    },
    props: {
        phrase: {
            type: Object,
            default: null,
        },
        speakers: {
            type: Array,
            default: () => [],
        },
        languages: {
            type: Array,
            default: () => [],
        },
        providers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localPhrase: {
                phrase: '',
                replace: '',
                is_active: true,
                provider: undefined,
                lang: [],
            },
            loading: false,
            error: undefined,
            shouldReload: false,
            keep: false,
        };
    },
    created() {
        if (this.phrase) {
            this.localPhrase = { ...this.phrase };
            this.localPhrase.lang = Array.isArray(this.phrase.language)
                ? this.phrase.language.map((lang) => lang.id)
                : [this.phrase.language.id];
            this.localPhrase.provider = this.phrase.provider.id;
        }
    },
    methods: {
        async save() {
            try {
                this.error = undefined;
                this.loading = true;
                let method = this.phrase ? 'patch' : 'post';
                let URL = this.phrase
                    ? `/api/v1/admin/phrase_dictionary/phrases/${this.phrase.id}/`
                    : '/api/v1/admin/phrase_dictionary/phrases/';

                let { phrase, replace, is_active, provider, lang } = this.localPhrase;

                let data = {
                    phrase,
                    replace,
                    is_active,
                    provider: provider,
                    languages: lang,
                };
                await ApiClient[method](URL, data);

                this.shouldReload = true;

                this.localPhrase = {
                    phrase: '',
                    replace: '',
                    is_active: true,
                    provider,
                    lang,
                };

                this.loading = false;

                if (this.keep) {
                    return;
                }

                this.$emit('closed', true);
            } catch (e) {
                console.log(e);
                this.error = e;
                this.loading = false;
            }
        },
        onClose() {
            this.$emit('closed', this.shouldReload);
        },
    },
};
</script>
